export default __webpack_public_path__ + "static/media/digitalist.f1ff94eb.svg";